// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2IoKB","calendarButtons":"ClockData_calendarButtons__10kKZ"};